import { required } from 'vuelidate/lib/validators'

export const validateData = {
  form: {
    conferencias: { required },
  },
}

export const validateComputed = {
  conferenciasErrors() {
    const errors = []
    if (!this.$v.form.conferencias.$dirty) return errors
    !this.$v.form.conferencias.required && errors.push('Campo obrigatório.')
    return errors
  },
}
